// extracted by mini-css-extract-plugin
export default {"container":"Slider-module__container__KnTLo","slider":"Slider-module__slider__lcGf0","label":"Slider-module__label__8D2D1"};